import { Pipe, PipeTransform } from '@angular/core';

import { EntityTypeEnum } from '../enums/entity-type.enum';
import { ISelectChoices } from '../interfaces/generic-select-config.interface';

@Pipe({
    name: 'filterRoleByEntity',
})
export class FilterRoleByEntity implements PipeTransform {
    public transform(roles: ISelectChoices[], mainRole?: EntityTypeEnum): ISelectChoices[] {
        if (mainRole) {
            const indexToSlice: number = this.findIndexInData(roles, 'value', mainRole);
            roles = roles.slice(indexToSlice);
            return roles.filter(
                (role: ISelectChoices) =>
                    role.value !== EntityTypeEnum.STUDENT &&
                    role.value !== EntityTypeEnum.ADMINISTRATOR &&
                    role.value !== EntityTypeEnum.RELATIVE &&
                    role.value !== mainRole
            );
        }
        return roles.filter(
            (role: ISelectChoices) =>
                role.value !== EntityTypeEnum.STUDENT &&
                role.value !== EntityTypeEnum.ADMINISTRATOR &&
                role.value !== EntityTypeEnum.RELATIVE
        );
    }

    private findIndexInData(data: any[], property: string, value: any): number {
        let result: number = -1;
        data.some((item: any, i: number) => {
            if (item[property] === value) {
                result = i;
                return true;
            }
            return false;
        });
        return result;
    }
}

@Pipe({
    name: 'removeParentRole',
})
export class RemoveParentRole implements PipeTransform {
    public transform(roles: ISelectChoices[]): ISelectChoices[] {
        return roles.filter((role: ISelectChoices) => role.value !== EntityTypeEnum.PARENT);
    }
}
